import ReportTemplateList from '../../views/ReportTemplate/ReportTemplateList';
import ReportTemplateEdit from '../../views/ReportTemplate/ReportTemplateEdit';

export default [
    {
        path: '/modelos-de-relatorios',
        name: 'report-template.list',
        component: ReportTemplateList,
        meta: {
            pageTitle: 'Modelos de Relatórios',
            breadcrumb: [
                { label: 'Modelos de Relatórios' },
            ],
        },
    },
    {
        path: '/modelos-de-relatorios/cadastro',
        name: 'report-template.create',
        component: ReportTemplateEdit,
        meta: {
            pageTitle: 'Cadastro de Modelo',
            breadcrumb: [
                { label: 'Modelos de Relatórios', routeName: 'report-template.list' },
                { label: 'Cadastro de Modelo' },
            ],
        },
    },
    {
        path: '/modelos-de-relatorios/:id',
        name: 'report-template.edit',
        component: ReportTemplateEdit,
        meta: {
            pageTitle: 'Edição de Modelo',
            breadcrumb: [
                { label: 'Modelos de Relatórios', routeName: 'report-template.list' },
                { label: 'Edição de Modelo' },
            ],
        },
    },
];
